// Mock data for Jotform Workspace clone

export const sidebarSections = {
  myWorkspace: [
    { id: 'all', name: 'All', icon: 'grid', active: true },
  ],
  teamWorkspaces: [],
  bottomItems: [
    { id: 'favorites', name: 'Favorites', icon: 'star' },
    { id: 'archive', name: 'Archive', icon: 'archive' },
    { id: 'trash', name: 'Trash', icon: 'trash' },
  ],
};

export const topNavItems = [
  { name: 'Templates', hasDropdown: true },
  { name: 'Integrations', hasDropdown: true },
  { name: 'Products', hasDropdown: true },
  { name: 'Support', hasDropdown: true },
  { name: 'Enterprise', hasDropdown: false },
  { name: 'Pricing', hasDropdown: false },
];

export const suggestionTags = [
  'Job Application Form',
  'Registration Form',
  'Feedback Form',
  'Contact Form',
  'Event Registration',
  'Order Form',
];

export const createCards = [
  {
    id: 'scratch',
    title: 'Start from scratch',
    description: 'A blank slate is all you need',
    color: 'bg-slate-100',
    icon: 'plus',
  },
  {
    id: 'import',
    title: 'Import form',
    description: 'Convert an existing form in seconds',
    color: 'bg-blue-100',
    icon: 'download',
    preview: 'blue',
  },
  {
    id: 'pdf',
    title: 'Document to Form',
    description: 'Convert your PDF to an online form',
    color: 'bg-red-100',
    icon: 'file-text',
    preview: 'red',
  },
  {
    id: 'sign',
    title: 'Collect Signatures',
    description: 'Request signatures with forms',
    color: 'bg-green-100',
    icon: 'pen',
    preview: 'green',
  },
  {
    id: 'template',
    title: 'Use template',
    description: 'Choose from a ready-made form',
    color: 'bg-orange-100',
    icon: 'layout-template',
    preview: 'orange',
  },
];

export const mockAssets = [
  {
    id: 'a1',
    name: 'Customer Feedback Survey',
    type: 'Form',
    typeColor: 'orange',
    submissions: 128,
    updatedAt: '2 hours ago',
    createdAt: 'May 12, 2025',
    status: 'Enabled',
    starred: true,
  },
  {
    id: 'a2',
    name: 'Employee Onboarding Workflow',
    type: 'Workflow',
    typeColor: 'purple',
    submissions: 32,
    updatedAt: '1 day ago',
    createdAt: 'Apr 30, 2025',
    status: 'Enabled',
    starred: false,
  },
  {
    id: 'a3',
    name: 'Q3 Sales Report',
    type: 'Report',
    typeColor: 'blue',
    submissions: 0,
    updatedAt: '3 days ago',
    createdAt: 'Apr 22, 2025',
    status: 'Enabled',
    starred: false,
  },
  {
    id: 'a4',
    name: 'Support Ticket System',
    type: 'App',
    typeColor: 'pink',
    submissions: 512,
    updatedAt: '5 hours ago',
    createdAt: 'Mar 18, 2025',
    status: 'Enabled',
    starred: true,
  },
  {
    id: 'a5',
    name: 'Marketing Contact List',
    type: 'Table',
    typeColor: 'green',
    submissions: 1204,
    updatedAt: '4 days ago',
    createdAt: 'Feb 08, 2025',
    status: 'Enabled',
    starred: false,
  },
  {
    id: 'a6',
    name: 'Vendor Agreement Template',
    type: 'Sign',
    typeColor: 'teal',
    submissions: 18,
    updatedAt: '1 week ago',
    createdAt: 'Jan 30, 2025',
    status: 'Enabled',
    starred: false,
  },
  {
    id: 'a7',
    name: 'AI Support Agent',
    type: 'Agent',
    typeColor: 'indigo',
    submissions: 892,
    updatedAt: '30 mins ago',
    createdAt: 'Jun 05, 2025',
    status: 'Enabled',
    starred: true,
  },
  {
    id: 'a8',
    name: 'Event Registration Form',
    type: 'Form',
    typeColor: 'orange',
    submissions: 245,
    updatedAt: '2 days ago',
    createdAt: 'May 28, 2025',
    status: 'Enabled',
    starred: false,
  },
  {
    id: 'a9',
    name: 'Product Launch Checklist',
    type: 'App',
    typeColor: 'pink',
    submissions: 44,
    updatedAt: '6 days ago',
    createdAt: 'Apr 15, 2025',
    status: 'Disabled',
    starred: false,
  },
  {
    id: 'a10',
    name: 'Weekly Team Standup',
    type: 'Workflow',
    typeColor: 'purple',
    submissions: 92,
    updatedAt: '2 weeks ago',
    createdAt: 'Mar 02, 2025',
    status: 'Enabled',
    starred: false,
  },
];
